"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const axios_1 = __importDefault(require("axios"));
function getColor(sample) {
    if (!sample) {
        return '#808081';
    }
    let group = sample.group;
    if (group && group.parent && group.parent.parent) {
        group = group.parent;
    }
    if (!group)
        return '#808080';
    return group.color;
}
/**
 * This is like an Array.map but it filter the null results
 * @param arr
 * @param fn
 */
function mapRemoveNulls(arr, fn) {
    const arr2 = arr.map(fn);
    return arr2.filter(b => b !== null);
}
class MapParcels {
    static async load(root) {
        const allSamples = root.flatSamples().map(fs => fs);
        const codes = allSamples.map(fs => fs.sample.firstCode);
        const response = await axios_1.default.get(`/toolkit/heatmap/api/map_parcels`, { params: { codes } });
        const data = response.data;
        const data2 = data.map(parcel => {
            const first_flat_sample = allSamples.find(fs => fs.sample.firstCode === parcel.samples[0].code);
            return {
                cluster_color: getColor(first_flat_sample),
                parcel_str: parcel.parcel_str,
                muestras: mapRemoveNulls(parcel.samples, sample => {
                    const flat_sample = allSamples.find(fs => fs.sample.firstCode === sample.code);
                    if (!flat_sample)
                        return null;
                    return {
                        cluster_color: getColor(flat_sample),
                        cluster_text: flat_sample.sample.code,
                        tierra: {
                            latitud: sample.lat,
                            longitud: sample.lon,
                        }
                    };
                }),
            };
        });
        console.log('data2');
        console.log(data2);
        return data2;
    }
}
exports.default = MapParcels;
